<template>
    <div class="flex w-full justify-center items-center h-screen">
        <div class="container w-[28rem] bg-[#f8f4f3] p-8 rounded-md">
            <a href="#" class="flex justify-center items-center pb-4 border-b border-b-gray-800 mb-4">
                <!-- タイトル -->
                <img src="/Vertical_144px.png" alt="logo" style="width: 144px; height: 144px;" class="w-full">
            </a>

            <el-form :model="form" label-width="auto">

                <el-form-item label="契約会社コード">
                    <el-input v-model="form.company_code" placeholder="契約会社コード" @keyup.enter="onSubmit"/>
                </el-form-item>

                <el-form-item label="管理者コード">
                    <el-input v-model="form.user_code" placeholder="管理者コード" @keyup.enter="onSubmit"/>
                </el-form-item>

                <el-form-item label="パスワード">
                    <el-input show-password v-model="form.password" placeholder="パスワード" @keyup.enter="onSubmit"/>
                </el-form-item>

                <div class="mb-6">
                    <p v-if="errorMessage" class="text-red-500  text-xs">{{ errorMessage }}</p>
                </div>
                <div class="flex justify-center">
                    <el-button type="primary" class="w-full" @click="onSubmit">ログイン</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
// import axios from 'axios';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import { authService } from '@/services/authService';
import { ROUTES } from '@/config/constants';

export default defineComponent({
    name: 'UserLogin',
    setup() {
        const form = ref({
            company_code: '',
            user_code: '',
            password: '',
        })
        const errorMessage = ref('');
        const router = useRouter();

        const onSubmit = async () => {
            try {
                
                const response = await axios.post('/api/login', {
                    company_code: form.value.company_code,
                    user_code: form.value.user_code,
                    password: form.value.password
                });

                authService.setUserInfo(response.data);

                // ログインしたらトップページに移動
                router.push(`/${ROUTES.DASHBOARD}`);
                ElMessage.info(`ログインしました！`);

            } catch (error) {
                errorMessage.value = '現場ID,ユーザーID,パスワードが間違っています。';
            }
        };



        return {
            form,
            errorMessage,
            onSubmit
        };
    }
});
</script>
